import React, { Component } from 'react';
import api from '../../api';

import Welcome from '../welcome';
import Error from '../error';
import Survey from '../survey';
import Goodbye from '../goodbye';
import Loading from '../loading';

import i18n from '../../utils/i18n';
import { ViewsEnum } from '../constants';

class Layout extends Component {
    survey_list; 

    constructor(props) {
        super(props);
        this.state = {
            survey: {},
            view: ViewsEnum.Loading,
            translation: this.props.translation
        }

        this.setSurvey = this.setSurvey.bind(this);
    }

    componentDidMount() {
        this.init(window.location.pathname.split('/'));
    }

    init(params) {
        localStorage.setItem('accessToken', params[1]);
        localStorage.setItem('country', params[2]);
        switch (params[2]) {
            case 'br':
                i18n.changeLanguage('br');
                break;
            default:
                i18n.changeLanguage('es');
        }
        this.setSurvey(params[3])
    }

    async setSurvey(source) {
        const surveysResponse = await api.getSurveys(source);
        let nextView = ViewsEnum.Survey

        if (surveysResponse.error) {
            nextView = ViewsEnum.Error;
            this.setView(nextView);
            return;
        }

        if(surveysResponse[source.toUpperCase()]) {
            const [survey] = surveysResponse[source.toUpperCase()]
            this.survey_list = surveysResponse[source.toUpperCase()];
            
            this.setState({survey});
            this.setView(nextView);
        }
    }

    setView(view) {
        this.setState({view});
    }

    nextStepSurvey(data) {
        this.setView(ViewsEnum.Loading);

        if(data?.survey){
            const survey = data.survey;
            this.setState({survey});
            setTimeout(() => {
                this.setView(data.view);
            }, 800);
        } else {
            if(data.view === ViewsEnum.Goodbay) {
                const searchIndex = this.survey_list.indexOf(this.state.survey);
                const newSurvey = this.survey_list[searchIndex + 1];
                let nextView = data.view; 

                if(newSurvey) {
                    nextView = ViewsEnum.Survey;
                    const survey = newSurvey;
                    this.setState({survey});
                }

                setTimeout(() => {
                    this.setView(nextView);
                }, 800);
            }
        }
    }

    ScreenView(props) {
        switch(props.view) {
            case ViewsEnum.Error:
                return <Error {...props}/>
            case ViewsEnum.Welcome:
                return <Welcome {...props}/>
            case ViewsEnum.Survey:
                return <Survey key={props.survey.id} {...props}/>
            case ViewsEnum.Goodbay:
                return <Goodbye key={props.survey.id} {...props}/>
            default:
                return <Loading/> 
        }
    }

    render() {
        return (
            <div className="Layout page">
                <div className="page__logo-container page__logo-container--colored">
                    <div className="page__header-wrapper">
                    <button className="page__close-button" type="button" aria-label="Close" onClick={  ()=>   window.open('gbrappi://com.grability.rappi?goto=home', '_self')  }>
                        <svg className="page__close-icon page__close-icon--light" width={25} height={25}>
                        <use xlinkHref="/images/sprite.svg#clear" />
                        </svg>
                    </button>
                    <a className="page__logo-wrapper" href="index.html">
                        <img className="page__logo" src="/images/logo-white.svg" alt="Rappi logo" />
                    </a>
                    </div>
                </div>
                {/* --------- */}
                <this.ScreenView {...this.state} next={ data => this.nextStepSurvey(data)   }/>
                {/* --------- */}
            </div>
        );
    }

}

export default Layout;
